import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import './RDPopover.scss';

const RDPopover = ({
  title,
  content,
  popoverBgColor,
  children,
  popoverDisabled,
  placement,
  defaultVisible,
  popoverStyles,
  isArrowPointAtCenter,
}) => (
  <Popover
    title={title}
    content={content}
    disabled={popoverDisabled}
    placement={placement}
    color={popoverBgColor}
    style={popoverStyles}
    defaultVisible={defaultVisible}
    arrowPointAtCenter={isArrowPointAtCenter}
  >
    {children}
  </Popover>
);

RDPopover.defaultProps = {
  title: '',
  content: '',
  popoverBgColor: '',
  popoverDisabled: false,
  cancelButtonStyle: {},
  placement: 'top',
  defaultVisible: false,
  popoverStyles: {},
  isArrowPointAtCenter: false,
};

RDPopover.propTypes = {
  /** Popover title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** React Node */
  children: PropTypes.element.isRequired,
  /** Text of the confirm button */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Background color of the popover */
  popoverBgColor: PropTypes.string,
  /** The cancel button style. */
  cancelButtonStyle: PropTypes.shape({}),
  /** Whether the popover is disabled or not */
  popoverDisabled: PropTypes.bool,
  /** Can be set to - topLeft | top | topRight | leftTop | left | leftBottom | rightTop | right | rightBottom | bottomLeft | bottom | bottomRight */
  placement: PropTypes.string,
  /** Whether the popover is visible by default */
  defaultVisible: PropTypes.bool,
  /** Style of the tooltip */
  popoverStyles: PropTypes.shape({}),
  /** Whether arrow points to the center of the target element */
  isArrowPointAtCenter: PropTypes.bool,
};

export default RDPopover;
